import gql from 'graphql-tag';

export const VO_LIST_DEAL_PIPE_LINE = gql`
  query GetVOListDealPipeline($input: VOListForDealPipelineInput!) {
    dealPipeline(input: $input) {
      summary {
        avgDealSize
        totalDealAmount
        totalActiveDeals
      }
      success
      entity {
        groupName
        list {
          deal {
            id
            closeStatus
            paymentType
            invoiceTotal
            businessName
            applicantName
            applicationType
            createdDateTime
            modifiedDateTime
            amount: amountRequested
          }
          stage {
            name
            businessProcessFlowId
            id: businessProcessFlowStageId
          }
        }
      }
    }
  }
`;
